module.exports = __webpack_public_path__ + "static/img/img4.66136a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img4.png
// module id = lUKc
// module chunks = 1